import React, {useEffect, useState} from 'react';
import {Container} from "@material-ui/core";
import {Redirect, useHistory} from "react-router-dom";
import {getNavigationUrl} from '../../navigation';
import {useShoppingCart} from "../../hooks/shoppingcart";
import {withRouter} from "react-router";

import ChangeQuantity from "./Components/Quantity";
import ChangeFilter from './Components/Filter';
import ChangeFormat from "./Components/Format";
import {usePriceList} from "../../../Providers/PriceListProvider";
import ExitDialog from "./Components/ExitDialog";
import ImageCrop from "./Components/ImageCrop";
import MainPage from "./Components/MainPage";
import WhiteBorder from "./Components/WhiteBorder";
import {productCropRectWillHaveWhiteBorders} from "../../../../lib/imageutils";

export default withRouter(({match}) => {
  console.log('Edit product page');
  const {items, updateOrderLine} = useShoppingCart ();
  const { calculateLinePrice, getProductByUuid } = usePriceList ();
  const [dirty, setDirty] = useState(false);
  const history = useHistory();
  const [showSaveChangesDialog, setShowSaveChangesDialog] = useState(false);
  const [currentPage, setCurrentPage] = useState('main')

  // We create a local copy of the order line so we can do local changes without saving
  const [orderLine, setOrderLine] = useState(() => {
    const ol = items.find(item => item.uuid == match.params.uuid);
    if (ol) {
      return {...ol}
    }
    return null;
  });

  useEffect(() => {
    const ol = items.find(item => item.uuid == match.params.uuid);
    if (ol) {
      setOrderLine({...ol})
    }
    else {
      setOrderLine(null)
    }
  }, [match]);

  useEffect(() => {
    // Load filter images to it goes quicker when you access them:
    if (!orderLine) {
      return;
    }

    const uuid = orderLine.files[0].uuid;
    const imageSize = 640;
    let type = 1;

    const img = new Image();
    img.src = `/system/XPhoto.php?uuid=${uuid}&scaleversion=${imageSize}&type=${type}&rotation=0`;

    type = 2;
    const img2 = new Image();
    img2.src = `/system/XPhoto.php?uuid=${uuid}&scaleversion=${imageSize}&type=${type}&rotation=0`;

  }, [orderLine])

  const handleCancel = (e) => {
    e.stopPropagation()
    if (!dirty) {
      doClose();
    } else {
      setShowSaveChangesDialog(true);
    }
  }

  const doClose = () => {
    history.push(`${getNavigationUrl('SHOPPING_CART')}/view/${orderLine.uuid}`);
  }

  const handleComplete = () => {
    if (dirty) {
      updateOrderLine(orderLine)
        .then(doClose)
    }
    else {
      // If no changes, just trigger cancel:
      doClose()
    }
  }

  const handleSetFormat = (format, resetCrop) => {
    setOrderLine((orderLine) => {
      const ol = {
        ...orderLine,
        product: format,
        actualLinePrice: calculateLinePrice(format.uuid, parseInt(orderLine.quantity)),
      };
      if (resetCrop) {
        ol.image = {
        ...orderLine.image,
            cropRect: null,

            // Without crop rect, everything is fill in:
            adaption: 0
        }
      }
      return ol;
    })
    setDirty(true);
    goToMainPage()
  }

  const handleSetCropRect = (cropRect) => {
    setOrderLine((orderLine) => {
      const product = getProductByUuid(orderLine.product.uuid)
      const adaption = productCropRectWillHaveWhiteBorders(product, cropRect, orderLine.files[0].size) ? 1 : 0;
      return {...orderLine,
        image: {
          ...orderLine.image,
          cropRect: cropRect,
          // Everything is "fit in" as the crop rect should fit it:
          adaption
        },
      };
    })
    setDirty(true);
    goToMainPage()
  }

  const handleSetQuantity = (quantity) => {
    quantity = parseInt(quantity);
    setOrderLine((orderLine) => {
      return {...orderLine,
        quantity: quantity,
        actualLinePrice: calculateLinePrice(orderLine.product.uuid, quantity)
      };
    })
    setDirty(true);
    goToMainPage()
  }

  const handleSetFilter = (filter) => {

    setOrderLine((orderLine) => {
      return {...orderLine,
        image: {
          ...orderLine.image,
          filter: filter
        }
      };
    })

    setDirty(true);
    goToMainPage()
  }

  const goToMainPage = () => {
    setCurrentPage('main')
  }

  if (!orderLine) {
    return <Redirect to={getNavigationUrl('SHOPPING_CART')} />
  }

  switch (currentPage) {
    case "main":
      return <>
        <MainPage orderLine={orderLine} onCancel={handleCancel} onComplete={handleComplete}
                  setCurrentPage={setCurrentPage}
        />
        <ExitDialog open={showSaveChangesDialog}
                    handleCancel={() => setShowSaveChangesDialog(false)}
                    handleOk={doClose} />
      </>
    case "filter":
      return <ChangeFilter orderLine={orderLine} onCancel={goToMainPage} setFilter={handleSetFilter}
                setCurrentPage={setCurrentPage}
      />
    case "quantity":
      return <ChangeQuantity orderLine={orderLine} onCancel={goToMainPage} setQuantity={handleSetQuantity}
      />
    case "format":
      return <ChangeFormat orderLine={orderLine} onCancel={goToMainPage} setFormat={handleSetFormat}
      />
    case "crop":
      return <ImageCrop orderLine={orderLine} onCancel={goToMainPage}
                        setFormat={handleSetFormat} setCropRect={handleSetCropRect}
      />
    case "white-border":
      return <WhiteBorder orderLine={orderLine} onCancel={goToMainPage} setFormat={handleSetFormat}
      />
  }
});
